<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol col="8" xl="6" class="text-center">
          <h1 class="mb-4">
            Limit Student Pass
            <HelpCenterButton
              classes="me-2"
              content-key="student_pass_limits"
            />
          </h1>
          <CreateLimitStudentPassForm
            is-in-view="true"
            :editable-pass-limit="editablePassLimit"
            @create-pass-limit="refreshDataTable()"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol md="12">
          <StudentPassLimitsTable ref="StudentPassLimitsTable" />
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import CreateLimitStudentPassForm from "@/components/Forms/CreateLimitStudentPassForm"
import StudentPassLimitsTable from "@/components/DataTables/StudentPassLimitsTable"
import HelpCenterButton from "@/components/HelpCenterButton"

import { mapGetters } from "vuex"

export default {
  name: "LimitStudentPass",
  components: {
    CreateLimitStudentPassForm,
    StudentPassLimitsTable,
    HelpCenterButton
  },
  computed: {
    ...mapGetters({
      editablePassLimit: "passLimits/editablePassLimit"
    })
  },
  methods: {
    refreshDataTable() {
      this.$refs.StudentPassLimitsTable.refreshDataTable()
    }
  }
}
</script>
